import http from './httpRequest.js'

class RtcPrivateApi {
}

RtcPrivateApi.prototype.setup = function (uid, mode) {
	return http({
		url: `/webrtc/private/setup?uid=${uid}&mode=${mode}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.accept = function (callId, uid) {
	return http({
		url: `/webrtc/private/accept?callId=${encodeURIComponent(callId)}&uid=${uid}`,
		method: 'post'
	})
}


RtcPrivateApi.prototype.handup = function (callId, uid) {
	return http({
		url: `/webrtc/private/handup?callId=${encodeURIComponent(callId)}&uid=${uid}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.cancel = function (callId, uid) {
	return http({
		url: `/webrtc/private/cancel?callId=${encodeURIComponent(callId)}&uid=${uid}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.reject = function (callId, uid) {
	return http({
		url: `/webrtc/private/reject?callId=${encodeURIComponent(callId)}&uid=${uid}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.failed = function (callId, uid, reason) {
	return http({
		url: `/webrtc/private/failed?callId=${encodeURIComponent(callId)}&uid=${uid}&reason=${encodeURIComponent(reason)}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.heartbeat = function (callId, uid) {
	return http({
		url: `/webrtc/private/heartbeat?callId=${encodeURIComponent(callId)}&uid=${uid}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.ready = function (callId, uid) {
	return http({
		url: `/webrtc/private/ready?callId=${encodeURIComponent(callId)}&uid=${uid}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.credentials = function (callId, uid) {
	return http({
		url: `/webrtc/private/credentials?callId=${encodeURIComponent(callId)}&uid=${uid}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.device = function (dto) {
	return http({
		url: '/webrtc/private/device',
		method: 'post',
		data: dto
	})
}

export default RtcPrivateApi;
